export default "__VITE_ASSET__Dqakz_mM__"